import { createContext, useState, useContext, useMemo, useEffect } from 'react';
import { getLevelInformationOfCustomer } from 'services/api/membership';
import { PointInformation } from 'services/api/type';
import { useWarrantyAuth } from './WarrantyAuthContext';

type ContextValue = {
  fetchMembershipLevel?: (body: void) => Promise<undefined>;
  memberLevelInformation?: PointInformation;
  loadingMembership: boolean;
};

const WarrantyPointContext = createContext<ContextValue>({
  memberLevelInformation: undefined,
  loadingMembership: false,
});

const WarrantyPointProvider = ({ children }: { children: React.ReactNode }) => {
  const [fetchMembershipLevel, { data, loading: loadingMembership }] = getLevelInformationOfCustomer();
  const { isWarranty, isLoggedIn } = useWarrantyAuth();

  useEffect(() => {
    if (isWarranty && isLoggedIn) {
      fetchMembershipLevel();
    }
  }, [isWarranty, isLoggedIn]);

  const [memberLevelInformation, setMemberLevelInformation] = useState<PointInformation>();

  useEffect(() => {
    setMemberLevelInformation(data);
  }, [data]);

  const context: ContextValue = useMemo(
    () => ({
      fetchMembershipLevel,
      memberLevelInformation,
      loadingMembership,
    }),
    [memberLevelInformation],
  );

  return <WarrantyPointContext.Provider value={context}>{children}</WarrantyPointContext.Provider>;
};

export function useWarrantyPoint(): ContextValue {
  return useContext<ContextValue>(WarrantyPointContext);
}

export default WarrantyPointProvider;
